import { PrinterConfigDto, UpsertPrinterConfigDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/printers`;

export const getAllPrinters = (source: CancelTokenSource): Promise<Array<PrinterConfigDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
}

export const searchPrinters = (query: String, source: CancelTokenSource): Promise<Array<PrinterConfigDto>> => {
  return axios
      .get(`${apiUri}/search`, {params: {query}, cancelToken: source.token})
      .then(response => response.data);
}

export const findPrinterById = (id: number, source: CancelTokenSource): Promise<UpsertPrinterConfigDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then( response => response.data)
}

export const savePrinter = (upserPrinterConfigDto: Partial<UpsertPrinterConfigDto>): Promise<PrinterConfigDto> => {
  return axios
      .post(apiUri, upserPrinterConfigDto)
      .then(response => response.data);
};

export const editPrinter = (id: number, upserPrinterConfigDto: Partial<UpsertPrinterConfigDto>): Promise<PrinterConfigDto> => {
  return axios
      .put(`${apiUri}/${id}`, upserPrinterConfigDto)
      .then(response => response.data);
};

export const deletePrinter = (id: number, source: CancelTokenSource): Promise<PrinterConfigDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
